import handleResponse from './request/handleResponse'

export default function(api: GlobalFetch) {
  return async function(
    pictures: string[],
    id_object: string,
    id_room: string,
  ) {
    const requestBody = {
      id_object,
      id_room,
      pictures,
    }
    const response = await api.fetch(`/api/v2/pictures/sort`, {
      body: JSON.stringify(requestBody),
      method: 'POST',
    })

    return await handleResponse(response)
  }
}
